import { Text, Heading } from "../../../../components/common/typography";
import { IconBuildingStore, IconShoppingCart } from "@tabler/icons-react";

interface PartnerRankingProps {
  customerRank: number | null | undefined;
  supplierRank: number | null | undefined;
}

export function PartnerRanking({ customerRank, supplierRank }: PartnerRankingProps) {
  const isBuyer = (customerRank ?? 0) > 0;
  const isSeller = (supplierRank ?? 0) > 0;

  return (
    <div className="bg-bgWhite rounded-xl p-6 border border-borderDefault">
      <Heading variant="h3" tone="dark" className="mb-4">
        Partner Ranking
      </Heading>
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <IconShoppingCart size={24} className="text-accentCyan shrink-0" />
          <div className="flex flex-col flex-1">
            <Text variant="bodyXs" tone="muted">Customer Rank</Text>
            <Text variant="bodyLgBold" tone="dark">
              {isBuyer ? customerRank : "Not a buyer"}
            </Text>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <IconBuildingStore size={24} className="text-accentGreen shrink-0" />
          <div className="flex flex-col flex-1">
            <Text variant="bodyXs" tone="muted">Supplier Rank</Text>
            <Text variant="bodyLgBold" tone="dark">
              {isSeller ? supplierRank : "Not a supplier"}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
